import React from "react";
import * as FaIcons from "react-icons/fa";
import * as SiIcons from "react-icons/si";
import * as TbIcons from "react-icons/tb";
import * as GrIcons from "react-icons/gr";

const SkillBullet = (data) => {
  const Icon =
    data.data.type === "fa"
      ? FaIcons[data.data.iconTitle]
      : data.data.type === "si"
      ? SiIcons[data.data.iconTitle]
      : data.data.type === "gr"
      ? GrIcons[data.data.iconTitle]
      : TbIcons[data.data.iconTitle];

  console.log(data.data.Title);

  return (
    <div className="relative group flex gap-3 items-center justify-center w-[8rem] h-[4.5rem] max-w-maxContent border text-richblack-200  border-blue-600 rounded-md bg-richblack-700 cursor-pointer hover:border-blue-400 hover:text-richblack-5 hover:bg-richblack-800 transition-all duration-200">
      <p className="absolute text-lg pt-[1.5rem]">{data.data.Title}</p>
      <Icon
        className={` absolute font-bold mb-[1.5rem] text-xl group-hover:text-2xl transition-all duration-300
      ${
        data.data.Title === "React" &&
        " group-hover:animate-[spin_4s_linear_infinite] group-hover:text-blue-200"
      }
      ${
        data.data.Title === "JavaScript" &&
        "group-hover:text-yellow-100 group-hover:animate-bounce "
      }
      ${data.data.Title === "Nextjs" && " group-hover:animate-bounce "}
      ${
        data.data.Title === "TypeScript" &&
        "group-hover:text-blue-100 group-hover:animate-bounce"
      }
      ${data.data.Title === "Cpp" && "group-hover:text-blue-100"}
      ${
        data.data.Title === "HTML" &&
        " group-hover:text-pink-200 group-hover:animate-bounce group-hover:text-4xl"
      }
      ${
        data.data.Title === "Node.js" &&
        " group-hover:text-caribbeangreen-200 group-hover:animate-bounce group-hover:font-bold"
      }
      ${
        data.data.Title === "MongoDB" &&
        " group-hover:text-caribbeangreen-500 group-hover:animate-pulse "
      }
      ${
        data.data.Title === "CSS" &&
        " group-hover:text-blue-100 group-hover:animate-pulse group-hover:scale-125"
      }`}
      />
    </div>
  );
};

export default SkillBullet;
